var _line, _line2, _line3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminderFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 3.71826,
    x2: 21,
    y2: 3.71826,
    stroke: "#1479FF",
    strokeWidth: 1.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 16.5605,
    x2: 21,
    y2: 16.5605,
    stroke: "#1479FF",
    strokeWidth: 1.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 10.1389,
    x2: 21,
    y2: 10.1389,
    stroke: "#1479FF",
    strokeWidth: 1.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12865 3.57894C6.12865 4.64876 5.24732 5.53264 4.13952 5.53264C3.03172 5.53264 2.15039 4.64876 2.15039 3.57894C2.15039 2.50912 3.03172 1.62524 4.13952 1.62524C5.24732 1.62524 6.12865 2.50912 6.12865 3.57894Z",
    fill: "white",
    stroke: "#1479FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12865 16.4212C6.12865 17.491 5.24732 18.3749 4.13952 18.3749C3.03172 18.3749 2.15039 17.491 2.15039 16.4212C2.15039 15.3514 3.03172 14.4675 4.13952 14.4675C5.24732 14.4675 6.12865 15.3514 6.12865 16.4212Z",
    fill: "white",
    stroke: "#1479FF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.029 9.99984C18.029 11.0697 17.1477 11.9535 16.0399 11.9535C14.9321 11.9535 14.0508 11.0697 14.0508 9.99984C14.0508 8.93002 14.9321 8.04614 16.0399 8.04614C17.1477 8.04614 18.029 8.93002 18.029 9.99984Z",
    fill: "white",
    stroke: "#1479FF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderFilterIcon);
export default __webpack_public_path__ + "static/media/reminder-filter-icon.40805bdc8de92da24559bee5c37335b3.svg";
export { ForwardRef as ReactComponent };